import { Lottie } from "./enums";

export const lottieMap = {
  [Lottie.CHECK_IN]: "/assets/lotties/check-in.lottie",
  [Lottie.SIGN_OUT]: "/assets/lotties/sign-out.lottie",
  [Lottie.VERIFIED_EMAIL]: "/assets/lotties/verified-email.lottie",
  [Lottie.VERIFY_EMAIL]: "/assets/lotties/verify-email.lottie",
  [Lottie.LOADING_SPINNER]: "/assets/lotties/loading-spinner.lottie",
};
